import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';

import {
    Table, Button, Tooltip, Modal, Row, Col,
} from 'antd';
import '../AddingMedToOrder/ShowAddedMedicines.css';
import {
    // ADD_MEDICINE_TO_LIST,
    DELETE_NONRXMEDICINE_FROM_LIST,
    // PUSH_MED_AT_INDEX_OF,
    RESET_ORDER_DETAIL,
    TOGGLE_FILTER,
} from '../../ActionTypes/ActionTypes';
// import AddNonRxMedicineModal from './AddNonRxMedicineModel';

const { Column } = Table;
const { confirm } = Modal;

class ShowAddedNonRxMedicineList extends Component {
    state = {
        doseInfo: '',
        doseFrequency: '',
        dosage_direction: '',
        data: {},
        editMedModal: '',
        medTableLoading: false,
        dataForEdit: {},
        selectedRowKeys: [],
        doctorMedLinkUpModal: false,
    };

    showEditMedModal = (indexId) => {
        const { medicineList } = this.props;
        const data = medicineList.filter((med, index) => index === indexId);
        this.setState({
            editMedModal: indexId,
            dataForEdit: data[0],
        });
    };

    handleEditMedCancel = () => {
        this.setState({ editMedModal: false });
    };

    saveFormRefMed = (formRef) => {
        this.formRefMed = formRef;
    };

    handleEditMedCreate = () => {
        const { form } = this.formRefMed.props;
        form.validateFields((err, values) => {
            if (err) {
                console.log(err);
                return;
            }
            console.log(values);
        });
    };

    extendMedicineDate = (indexId) => {
        const { medicineList, end_date, pushMedAtIndexOf } = this.props;

        this.setState({ medTableLoading: true });

        const data = medicineList.filter((med, index) => index === indexId);

        const values = data[0];

        values.end_date = end_date;

        if (values.id !== undefined) {
            // make use of id to submit directly to database
            axios({
                method: 'put',
                url: `/prescription_medicines/${values.id}.json`,
                headers: { Authorization: sessionStorage.getItem('jwtToken') },
                data: {
                    prescription_medicine: {
                        end_date: values.end_date,
                    },
                },
            })
                .then((response) => {
                    pushMedAtIndexOf(indexId, response.data);
                    this.setState({ medTableLoading: false });
                });
        }
    };

    showStopConfirm = (indexId) => {
        const { medicineList, pushMedAtIndexOf } = this.props;

        confirm({
            title: 'Do you want to stop this medicine?',
            content: 'Sets end-date to today',
            onOk: () => {
                this.setState({ medTableLoading: true });
                const data = medicineList.filter((med, index) => index === indexId);
                const values = data[0];
                // console.log('hello');
                values.end_date = moment().format('YYYY-MM-DD');

                // console.log(values.end_date);

                if (values.id !== undefined) {
                    // make use of id to submit directly to database
                    // console.log('running here');
                    axios({
                        method: 'put',
                        url: `/prescription_medicines/${values.id}.json`,
                        headers: { Authorization: sessionStorage.getItem('jwtToken') },
                        data: {
                            prescription_medicine: {
                                end_date: values.end_date,
                            },
                        },
                    })
                        .then((response) => {
                            console.log(response.data);
                            pushMedAtIndexOf(indexId, response.data);
                            this.setState({ medTableLoading: false });
                        });
                }
            },
            onCancel: () => {

            },
        });
    };

    deleteAddedMedicine = async (countId, id) => {
        const { deleteMedicineFromMedicineList } = this.props;
        this.setState({ medTableLoading: true });
        await axios({
            method: 'delete',
            url: `/non_prescription_medicines/${id}.json`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then(() => {
                deleteMedicineFromMedicineList(countId);
                this.setState({ medTableLoading: false });
            });
    }

    handleSendMed = (event) => {
        event.preventDefault();

        const {
            order_id, medicineList,
            resetOrderDetail, history, p_prescriptions_url,
        } = this.props;

        const lolol = [];

        /* eslint-disable */
        medicineList.map( ( med ) => {
            delete med.id;
            lolol.push( med );
        } );

        // console.log(lolol);

        axios( {
            method: 'post',
            url: '/e_prescriptions.json',
            headers: { Authorization: sessionStorage.getItem( 'jwtToken' ) },
            data: {
                e_prescription: {
                    order_id,
                    prescription_medicines: lolol, //  structure is - [{},{}] - this is fine.
                    p_prescriptions: p_prescriptions_url, //  structure is - [{"photo_link": ''},{"photo_link": ''}]
                },
            },
        } )
            .then( () => {
                resetOrderDetail();
                history.push( '/allOrders' );
            } )
            .catch( ( error ) => {
                console.log( error );
            } );
    }

    handleDoseInfo = ( values ) => {
        this.setState( { doseInfo: values } );
    };

    handleDoseDirection = ( values ) => {
        this.setState( { dosageDirection: values } );
    };

    handleDoseFrequency = ( values ) => {
        this.setState( { doseFrequency: values } );
    };

    handleSubmitFromDosageDirection = ( values ) => {
        const { dataForEdit, doseInfo } = this.state;
        const { medicineList, pushMedAtIndexOf, e_prescription_id } = this.props;
        // console.log(e_prescription_id === "");
        // this.state.dataForEdit.id is undefined when no id
        if ( e_prescription_id !== '' || e_prescription_id == null ) {
            // make use of id to submit directly to database
            axios( {
                method: 'put',
                url: `/prescription_medicines/${dataForEdit.id}.json`,
                headers: { Authorization: sessionStorage.getItem( 'jwtToken' ) },
                data: {
                    prescription_medicine: {
                        ...doseInfo,
                        ...values,
                    },
                },
            } )
                .then( () => {
                    // first delete from medList based on the medicine_id and then add it to the database
                    // deleting first
                    const indexId = medicineList.indexOf( dataForEdit );
                    // console.log(indexId);

                    const data = {
                        id: dataForEdit.id,
                        medicine_id: dataForEdit.medicine_id,
                        name: dataForEdit.name,
                        ...doseInfo,
                        ...values,
                        frequency: dataForEdit.frequency,
                        doctor_id: dataForEdit.doctor_id,
                        month_days: dataForEdit.month_days,
                        week_days: dataForEdit.week_days,
                        day_num: dataForEdit.day_num,
                        option_type: dataForEdit.option_type,
                        month_day_occurrence: dataForEdit.month_day_occurrence,
                        url: dataForEdit.url,
                        start_date: dataForEdit.start_date,
                        end_date: dataForEdit.end_date,
                    };

                    pushMedAtIndexOf( indexId, data );
                    window.location.reload();
                } );
        } else {
            // first delete from medList based on the medicine_id and then add it to the database
            // deleting first
            const indexId = medicineList.indexOf( dataForEdit );

            const data = {
                medicine_id: dataForEdit.medicine_id,
                doctor_id: dataForEdit.doctor_id,
                name: dataForEdit.name,
                ...doseInfo,
                ...values,
                frequency: dataForEdit.frequency,
                month_days: dataForEdit.month_days == null
                    ? ''
                    : dataForEdit.month_days,
                week_days: dataForEdit.week_days == null
                    ? ''
                    : dataForEdit.week_days,
                day_num: dataForEdit.day_num == null
                    ? ''
                    : dataForEdit.day_num,
                month_day_occurrence: dataForEdit.month_day_occurrence == null
                    ? ''
                    : dataForEdit.month_day_occurrence,
                start_date: dataForEdit.start_date == null
                    ? ''
                    : dataForEdit.start_date,
                end_date: dataForEdit.end_date == null
                    ? ''
                    : dataForEdit.end_date,
            };

            pushMedAtIndexOf( indexId, data );
            window.location.reload();
        }
    }

    handleMedicineTenure = ( values ) => {
        // console.log(values);

        const {
            dataForEdit, doseInfo, doseFrequency, dosageDirection,
        } = this.state;

        const { e_prescription_id } = this.props;

        const medTenure = values;

        const { medicineList, pushMedAtIndexOf } = this.props;
        // this.state.dataForEdit.id is undefined when no id
        if ( e_prescription_id !== '' || e_prescription_id == null ) {
            // make use of id to submit directly to database
            axios( {
                method: 'put',
                url: `/prescription_medicines/${dataForEdit.id}.json`,
                headers: { Authorization: sessionStorage.getItem( 'jwtToken' ) },
                data: {
                    prescription_medicine: {
                        ...doseInfo,
                        ...doseFrequency,
                        ...dosageDirection,
                        ...medTenure,
                    },
                },
            } )
                .then( () => {
                    // console.log(response);
                    // first delete from medList based on the medicine_id and then add it to the database
                    // deleting first
                    const indexId = medicineList.indexOf( dataForEdit );
                    // console.log(indexId);

                    const data = {
                        id: dataForEdit.id,
                        medicine_id: dataForEdit.medicine_id,
                        name: dataForEdit.name,
                        doctor_id: dataForEdit.doctor_id,
                        ...doseInfo,
                        ...doseFrequency,
                        ...dosageDirection,
                        ...medTenure,
                    };

                    pushMedAtIndexOf( indexId, data );
                    window.location.reload();
                } );
        } else {
            // first delete from medList based on the medicine_id and then add it to the database
            // deleting first
            const indexId = medicineList.indexOf( dataForEdit );

            const data = {
                medicine_id: dataForEdit.medicine_id,
                name: dataForEdit.name,
                doctor_id: dataForEdit.doctor_id,
                ...doseInfo,
                ...doseFrequency,
                ...dosageDirection,
                ...medTenure,
            };

            pushMedAtIndexOf( indexId, data );
            window.location.reload();
        }
    }

    showDocMedLinkUp = () => {
        this.setState( {
            doctorMedLinkUpModal: true,
        } );
    }

    handleDocMedLinkUpCancel = () => {
        this.setState( {
            doctorMedLinkUpModal: false,
        } );
    }

    render () {
        const {
            order_id, medicineList, e_prescription_id, deleteMedicineFromMedicineList,
            history, filter, toggleFilter, nonRxMedicineList,
        } = this.props;
        const {
            dataForEdit, medTableLoading, editMedModal, doctorMedLinkUpModal,
        } = this.state;
        const {
            medicine_id, name, salt, price, form,
        } = dataForEdit;


        return (
            <div style={{ width: '98%', margin: 'auto', marginTop: '2%' }}>

                <Row type="flex" justify="center">
                    <Col>
                        <h2 style={{ textAlign: 'center' }}>
                            Non Rx Medicines in {order_id}
                        </h2>
                    </Col>
                </Row>

                <hr width="100px" />

                <Table
                    className="mainTable"
                    dataSource={
                        nonRxMedicineList
                    }
                    scroll={{ x: 1175 }}
                    loading={medTableLoading}
                    size="middle"
                    rowKey="id"
                    style={{ overflow: 'wrap' }}
                >
                    <Column
                        title="# med"
                        width={75}
                        fixed="left"
                        align="center"
                        dataIndex="medicine_id"
                    />
                    <Column
                        title="Name"
                        dataIndex="med_name"
                        width={200}
                        fixed="left"
                        align="center"
                    />
                    <Column
                        title="Strip/Unit"
                        dataIndex="non_prescription_medicine_strip"
                        width={100}
                        align="center"
                    />
                    <Column
                        title="Per Strip/Unit"
                        dataIndex="non_prescription_medicine_per_strip"
                        width={100}
                        align="center"
                    />
                    <Column
                        title="Extra"
                        dataIndex="non_prescription_medicine_extra_pill"
                        width={150}
                        align="center"
                    />
                    <Column
                        title="Start"
                        dataIndex="non_prescription_medicine_start_date"
                        width={150}
                        align="center"
                    />
                    <Column
                        title="End"
                        // dataIndex="end_date"
                        render={( record => ( moment( record.non_prescription_medicine_end_date ).isValid() ? record.non_prescription_medicine_end_date : '–' ) )}
                        width={150}
                        align="center"
                    />
                    <Column
                        title="Duration(days)"
                        render={( record ) => {
                            const start = moment( record.non_prescription_medicine_start_date );
                            const end = moment( record.non_prescription_medicine_end_date );
                            return <p>{isNaN( end.diff( start, 'days' ) + 1 ) ? '–' : end.diff( start, 'days' ) + 1}</p>;
                        }}
                        width={150}
                        align="center"
                    />
                    <Column
                        title="Total"
                        dataIndex="non_prescription_medicine_total_quantity"
                        width={100}
                        align="center"
                    />
                    <Column
                        title="Actions"
                        width={250}
                        render={record => (
                            <Tooltip placement="top" title="Delete this medicine">
                                <span>
                                    {
                                        e_prescription_id === ''
                                            ? (
                                                <Button
                                                    type="danger"
                                                    shape="circle"
                                                    icon="delete"
                                                    onClick={() => deleteMedicineFromMedicineList( nonRxMedicineList.indexOf( record ) )}
                                                />
                                            )
                                            : (
                                                <Button
                                                    type="danger"
                                                    shape="circle"
                                                    icon="delete"
                                                    onClick={() => this.deleteAddedMedicine( nonRxMedicineList.indexOf( record ), record.id )}
                                                />
                                            )
                                    }
                                </span>
                            </Tooltip>
                        )}
                    />

                </Table>

                <div style={{ marginTop: '5%' }}>
                    {/* TODO - remove this after adding doctors page */}
                    {
                        e_prescription_id === ''
                            ? <Button type="primary" onClick={this.handleSendMed}>Submit Medicines</Button>
                            : <Button type="primary" onClick={() => history.push( '/allOrders' )}>Done</Button>
                    }

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ( {
    filter: state.AppState.filter,
    nonRxMedicineList: state.AppState.nonRxMedicineList,
    medicineList: state.AppState.medicineList,
    order_id: state.AppState.order_id,
    user_id: state.AppState.user_id,
    doctor_id: state.AppState.doctor_id,
    photo_link: state.AppState.photo_link,
    start_date: state.AppState.start_date,
    end_date: state.AppState.end_date,
    e_prescription_id: state.AppState.ep_id,
    p_prescriptions_url: state.AppState.p_prescriptions_url,
} );

const mapDispatchToProps = dispatch => ( {
    deleteMedicineFromMedicineList: id => dispatch( { type: DELETE_NONRXMEDICINE_FROM_LIST, id } ),
    resetOrderDetail: () => dispatch( { type: RESET_ORDER_DETAIL } ),
    toggleFilter: () => dispatch( { type: TOGGLE_FILTER } ),
} );


export default connect( mapStateToProps, mapDispatchToProps )( withRouter( ShowAddedNonRxMedicineList ) );



// WEBPACK FOOTER //
// ./src/component/AddingNonRxMedicines/ShowAddedNonRxMedicineList.js